import { render, staticRenderFns } from "./PerformanceMarketingWhySection.vue?vue&type=template&id=118e6373"
import script from "./PerformanceMarketingWhySection.vue?vue&type=script&lang=js"
export * from "./PerformanceMarketingWhySection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports